/**
 * site_audience_manifest — Studio Audience pane SSOT (D15 · D31)
 */

import type { SitePricingAudience } from '@shared/site/pricing/partner-pricing-types';

export type SiteAudienceRole = SitePricingAudience | 'internal_site';

export interface SiteAudienceManifest {
  /** pageSlug → visible audiences */
  pageVisibility: Record<string, SiteAudienceRole[]>;
  /** sectionId → visible audiences */
  sectionVisibility: Record<string, SiteAudienceRole[]>;
  /** nav item id → visible audiences */
  navVisibility: Record<string, SiteAudienceRole[]>;
  /** virtualSpaceId → partner feature keys visible */
  partnerFeatures: Record<string, string[]>;
  /** feature key or `${virtualSpaceId}:${featureId}` → allowed partner tier ids (empty/absent = all tiers) */
  partnerTierIds: Record<string, string[]>;
}

export const EMPTY_AUDIENCE_MANIFEST: SiteAudienceManifest = {
  pageVisibility: {},
  sectionVisibility: {},
  navVisibility: {},
  partnerFeatures: {},
  partnerTierIds: {},
};
